import { render } from "./gatewayModal.vue?vue&type=template&id=c8a4ced6"
import script from "./gatewayModal.vue?vue&type=script&lang=js"
export * from "./gatewayModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__